import { render, staticRenderFns } from "./VitalsPage.vue?vue&type=template&id=5acf1a14&"
import script from "./VitalsPage.vue?vue&type=script&lang=ts&"
export * from "./VitalsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5acf1a14')) {
      api.createRecord('5acf1a14', component.options)
    } else {
      api.reload('5acf1a14', component.options)
    }
    module.hot.accept("./VitalsPage.vue?vue&type=template&id=5acf1a14&", function () {
      api.rerender('5acf1a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/VitalsPage.vue"
export default component.exports